export default {
  environment: "production",
  backendUrl: "https://internal-api.zobaze.com",
  serverlessUrl: "https://pos.zobaze.com",
  debugMode: false,
  firebaseConfig: {
    apiKey: "AIzaSyCzui7T79bC8RTrI7GIIq3bMpU3ZxgsN3k",
    authDomain: "zobaze-pos.firebaseapp.com",
    databaseURL: "https://zobaze-pos.firebaseio.com",
    projectId: "zobaze-pos",
    storageBucket: "zobaze-pos.appspot.com",
    messagingSenderId: "911396625074",
    appId: "1:911396625074:web:cd2681cdddbedb760487ab",
    measurementId: "G-WMPMLKBV0G",
  },
};
